import React from "react";
import { GiftIcon } from "lucide-react";
import { bonuses } from "../../data/content";
import { CtaButton } from "../CtaButton";
export function Bonuses() {
  return <section className="bg-white py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-89" data-mp="1cl6258j3xigj">
      <div className="mx-auto max-w-4xl px-4 sm:px-5" data-id="element-90" data-mp="1cj3f8xd945g1">
        <div className="flex justify-center" data-id="element-91" data-mp="18kduuktspnmw">
          <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gold text-ink" data-id="element-92" data-mp="18hhwive1cwxx">
            <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-93" data-mp="257hdne8953s4" />
          </span>
        </div>
        <h2 id="bonus-title" className="mt-5 text-center font-display text-[32px] font-black leading-tight text-ink sm:text-[44px]" data-id="element-94" data-mp="208ny7g9en2pb">
          And I'm giving you <em className="text-brand" data-id="element-95" data-mp="1ravgy6k4hkza">5 bonuses free</em>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[17px] leading-relaxed text-muted" data-id="element-96" data-mp="ku0alghgct2v">
          I didn't want to stop at the six volumes. So I'm adding 5 additional resources you can use alongside the Safe
          Spine Method™.
        </p>
        <p className="mt-4 text-center text-lg font-bold text-ink" data-id="element-97" data-mp="1eu6j0w1smjn3">
          Total bonus value: <span className="text-flame line-through" data-id="element-98" data-mp="1jrggmyzc61m0">$147</span>{" "}
          <span className="text-brand" data-id="element-99" data-mp="15t8l8vhy78cy">— Included FREE today</span>
        </p>

        <div className="mt-12 space-y-14" data-id="element-100" data-mp="15vbf5qm81lmy">
          {bonuses.map(b => <article key={b.number} className="overflow-hidden rounded-3xl border border-line bg-paper" data-id="element-101" data-mp="1aq8luqw13iwo">
              <div className="bg-white" data-id="element-102" data-mp="w12nt68xfyqd">
                <img src={b.image} alt={`Bonus #${b.number}: ${b.title}`} className="block w-full" loading="lazy" data-id="element-103" data-mp="10uf6kzqxdbb7" />
              </div>
              <div className="p-5 sm:p-8" data-id="element-104" data-mp="n423pbsw4msq">
                <div className="flex flex-wrap items-center gap-2" data-id="element-105" data-mp="r42i4wfzoxzs">
                  <span className="rounded-full bg-gold px-3.5 py-1 text-sm font-extrabold uppercase text-ink" data-id="element-106" data-mp="r4cagqoibh8n">
                    Bonus #{b.number}
                  </span>
                  <span className="text-sm font-semibold text-muted" data-id="element-107" data-mp="i22z5ylezju7">
                    Value: <span className="line-through" data-id="element-108" data-mp="2jstm66yrtqom">${b.value}</span>
                  </span>
                  <span className="rounded-full bg-brand px-3 py-1 text-sm font-extrabold uppercase text-white" data-id="element-109" data-mp="2f1blzl4knu4p">Free</span>
                </div>
                <h3 className="mt-4 font-display text-[26px] font-black leading-tight text-ink sm:text-[30px]" data-id="element-110" data-mp="2b0hz8v2v8lde">{b.title}</h3>
                <p className="mt-3 text-[16px] leading-relaxed text-muted" data-id="element-111" data-mp="25zc7azh1524x">{b.text}</p>
                {b.chips.length > 0 && <ul className="mt-4 flex flex-wrap gap-2" data-id="element-112" data-mp="2ypavksnegv8j">
                    {b.chips.map(c => <li key={c} className="rounded-lg border border-line bg-white px-3 py-1.5 text-[13px] font-semibold text-navy" data-id="element-113" data-mp="2tpybugrts4a6">
                        {c}
                      </li>)}
                  </ul>}
                {b.tagline && <p className="mt-4 text-[17px] font-bold text-brand" data-id="element-114" data-mp="1dchmg1gaw0qx">{b.tagline}</p>}
              </div>
            </article>)}
        </div>

        <div className="mt-12" data-id="element-115" data-mp="139vsopptwhss">
          <CtaButton label="Yes, I want all 5 bonuses" caption="$147 in bonuses included free with your purchase" data-id="element-116" data-mp="136gf5rbszgth" />
        </div>
      </div>
    </section>;
}